<div class="ui-tag" [class.isFullSize]="isFullSize()" [ngClass]="tagType()" [class.clickable]="isClickable()">
	<ng-content></ng-content>
</div>
